var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.hasSlides
    ? _c("swiper", {
        staticClass: "main-banner main-banner__slider",
        attrs: { items: _vm.BANNERS, dots: "", autoplay: "" },
        scopedSlots: _vm._u(
          [
            {
              key: "default",
              fn: function(ref) {
                var item = ref.item
                var index = ref.index
                var isActive = ref.isActive
                return [
                  _c("banner", {
                    attrs: {
                      "back-as-img": false,
                      index: index,
                      data: item,
                      "in-slider": "",
                      "is-active": isActive,
                      "slot-name": "MAIN_SLIDER"
                    }
                  })
                ]
              }
            }
          ],
          null,
          false,
          2955668933
        )
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }